if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const current = event.detail.currentElement;

  const thumbnail = this.elements.thumbnails.querySelector(
    `[data-target="${current.dataset.mediaId}"]`
  );
  this.setActiveThumbnail(thumbnail);

  // 👇 THIS is the missing piece: when swiping, actually play the active slide
  this.playActiveMedia(current);
}

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

playActiveMedia(activeItem) {
  // Stop other media first
  window.pauseAllMedia?.();

  // 1) Prefer clicking the actual poster play button (most reliable in Dawn forks)
  const posterBtn =
    activeItem.querySelector('.deferred-media__poster-button') ||
    activeItem.querySelector('[data-media-id] .deferred-media__poster-button');
  if (posterBtn) {
    try { posterBtn.click(); } catch (e) {}
  } else {
    // Fallback: call the deferred element directly if present
    const deferred = activeItem.querySelector('deferred-media, .deferred-media');
    if (deferred && typeof deferred.loadContent === 'function') {
      try { deferred.loadContent(false); } catch (e) {}
    }
  }

  // 2) Once a <video> is in the DOM, force inline autoplay + loop
  const primeAndPlay = (video) => {
    if (!video) return;

    // Required for mobile inline autoplay
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');

    // Optional: hide controls on mobile
    const isMobile = matchMedia('(pointer: coarse), (max-width: 1024px)').matches;
    if (isMobile) video.removeAttribute('controls');

    try { video.load?.(); } catch (_) {}
    const tryPlay = () => video.play?.().catch(() => {});
    tryPlay();
    const onReady = () => { tryPlay(); video.removeEventListener('loadeddata', onReady); };
    video.addEventListener('loadeddata', onReady, { once: true });
  };

  // 3) Poll briefly + observe mutations to catch when the theme injects the <video>
  let tries = 0;
  const maxTries = 12; // ~1.2s
  const tick = () => {
    const v = activeItem.querySelector('video');
    if (v) return primeAndPlay(v);
    if (++tries < maxTries) setTimeout(tick, 100);
  };
  tick();

  const mo = new MutationObserver(() => {
    const v = activeItem.querySelector('video');
    if (v) { mo.disconnect(); primeAndPlay(v); }
  });
  mo.observe(activeItem, { childList: true, subtree: true });
  setTimeout(() => mo.disconnect(), 2000);
}




      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

